import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '@public/constants/ui';

const titleColor = '#07003D';
const textColor = '#44546B';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backgroundImg: {
      bottom: 0,
      position: 'absolute',
      width: '100%',
      zIndex: 0,
    },
    img: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      width: '100%',
    },
    pageContainer: {
      alignItems: 'center',
      display: 'flex',
      height: `calc(100vh - ${HEADER_HEIGHT}px)`,
      justifyContent: 'center',
      minHeight: 768,
      position: 'relative',

      [theme.breakpoints.down('xs')]: {
        flexDirection: 'row',
        height: `calc(100vh - ${MOBILE_HEADER_HEIGHT}px)`,
        padding: 0,
      },
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      padding: theme.spacing(8, 12),
      position: 'relative',
      width: 416,
      left: 0,
      top: 0,
      height: '100%',
      zIndex: 4,
      '@media (max-height:910px)': {
        height: 'auto',
      },

      [theme.breakpoints.down('xs')]: {
        backgroundColor: 'inherit',
        borderRadius: 0,
        boxShadow: 'none !important',
        width: '100%',
        padding: theme.spacing(7),
      },

      '@media (max-width:350px)': {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(2),
      },
    },
    paperSpecial: {
      boxSizing: 'border-box',
      padding: theme.spacing(8, 12),
      position: 'relative',
      width: 416,
      zIndex: 4,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',

      [theme.breakpoints.down('xs')]: {
        backgroundColor: 'inherit',
        borderRadius: 0,
        boxShadow: 'none !important',
        width: '100vw',
      },

      '@media (max-width:350px)': {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(2),
      },
    },
    title: {
      lineHeight: '60px',

      [theme.breakpoints.down('xs')]: {
        fontSize: '1.85rem !important',
      },
    },
    titleContainer: {
      height: 76,
      padding: theme.spacing(2),
    },
    userLicenseLink: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      textDecoration: 'underline',

      '&:hover, &:visited': {
        color: theme.palette.primary.main,
      },
    },
    content: {
      flex: 1,
      minWidth: 0,
    },
    consentList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    },
    consentRow: {
      alignItems: 'flex-start',
      color: '#fff',
      display: 'flex',
      fontSize: 16,
      lineHeight: '20px',

      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
        lineHeight: '18px',
      },
    },
    consentCheckbox: {
      color: '#fff !important',
      padding: '0 8px 0 0',

      '& svg': {
        fill: '#fff',
      },
    },
    userLicenseText: {
      marginTop: 20,
      width: '100% !important',
    },

    feedback: {
      marginTop: 32,
    },
    link: {
      fontSize: 13,
      cursor: 'pointer',
      color: theme.palette.primary.main,
    },
    supportLink: {
      fontSize: '17px',
      cursor: 'pointer',
      color: theme.palette.primary.main,
    },
    logo: {
      marginBottom: '80px',
      '& img': {
        width: 'auto',
      },

      [theme.breakpoints.down('xs')]: {
        marginBottom: '50px',
      },
    },
    particles: {
      zIndex: 2,
      overflow: 'hidden',
    },
    waveImg: {
      marginLeft: '-50px',
      position: 'absolute',
      top: '-150px',
      width: `calc(100% + ${theme.spacing(16)}px)`,
      zIndex: -1,
      transform: 'scale(-1,1)',
      [theme.breakpoints.down('xs')]: {
        marginLeft: -theme.spacing(4),
        width: `calc(100% + ${theme.spacing(8)}px)`,
      },
    },
    logoContainer: {
      width: '100%',
      height: '30%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
    },
    logoElem: {
      '& img': {
        width: '150px',
        filter: 'grayscale(1)',
        opacity: '0.4',
        '&:hover': {
          opacity: 1,
          filter: 'none',
          transition: '0.8s',
        },
      },
      '@media (max-height:910px)': {
        position: 'static',
        display: 'block',
        marginTop: theme.spacing(8),
      },
    },
    sliderContainer: {
      width: 'calc(100% - 416px)',
      overflowX: 'hidden',
    },
    specialImageContainer: {
      width: 'calc(100% - 416px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    titleSpecial: {
      fontSize: 24,
      color: titleColor,
      marginTop: theme.spacing(8 * 2),
      [theme.breakpoints.down('sm')]: {
        fontSize: 18,
      },
    },
    textSpecial: {
      color: textColor,
      marginTop: theme.spacing(6),
      whiteSpace: 'pre-wrap',
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
    specialContainer: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',

      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    paperAnchorLeft: {
      borderRight: 'none',
    },

    drawer: {
      width: 416,

      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },

    addToSlider: {
      marginLeft: 416,
    },
  }),
);
